import * as v from 'valibot';

const DisenrollmentStatus = v.fallback(
  v.union([
    v.literal('ok'), // user got disenrolled
    v.literal('notfound'), // enrollment is not found.
    v.literal('disabled'), // enrollment is disabled.
    v.literal('unknown'),
  ]),
  'unknown',
);

export const DisenrollmentRequestSchema = v.object({
  status: DisenrollmentStatus,
});

export type TDisenrollmentStatus = v.Output<typeof DisenrollmentStatus>;
